// extracted by mini-css-extract-plugin
export default {"skipLink":"basePage_skipLink__FRYXS"};